import React from 'react';
import { Link, Outlet, useLocation } from 'react-router-dom';
import { Menu } from 'antd';
import colors from '../../scss/variables.module.scss';

/* purchase sub menu data */
const purchaseSubMenu = [
  { name: 'Product Bags', path: '/purchaseOrders/productBags' },
  { name: 'Paddy Bags', path: '/purchaseOrders/paddyBags' },
  { name: 'Other Items', path: '/purchaseOrders/otherItems' },
];

/* React functional component */
const PurchaseTabLayout = () => {
  /* extracting location from useLocation hook */
  const location = useLocation();

  return (
    <div className="subMenu">
      <Menu
        style={{ backgroundColor: colors.colorBlack, display: 'flex' }}
        selectedKeys={[location.pathname]}
        className="sub"
      >
        {purchaseSubMenu.map((item) => {
          return (
            <Menu.Item key={item.path} className="hideInPrint">
              <Link to={item.path} style={{ fontWeight: '500', fontSize: 14 }}>
                {item.name}
              </Link>
            </Menu.Item>
          );
        })}
      </Menu>
      <Outlet />
    </div>
  );
};

export default PurchaseTabLayout;
